import ConfirmationDialog from "./confirmationDialog.container";

export default ConfirmationDialog;